<template>
  <transition name="rt-notification-fade">
    <div
      v-show="visible"
      :class="['rt-notification', customClass, horizontalClass]"
      :style="positionStyle"
      role="alert"
      @mouseenter="clearTimer()"
      @mouseleave="startTimer()"
      @click="click"
    >
      <i
        v-if="type || iconClass"
        :class="[typeClass, iconClass]"
        class="rt-notification__icon"
      > </i>
      <div
        :class="{ 'is-with-icon': typeClass || iconClass }"
        class="rt-notification__group"
      >
        <div class="rt-header">
          <slot name="header-icon">
            <rt-icon
              :color="SCSS_VARIABLES.COLOR_NORMAL"
              name="rt-base-notification"
              size="16"
            />
          </slot>
          <div class="rt-header__title">
            {{ $tx('消息通知', 'xpc.common.messageNotification') }}
          </div>
          <rt-button
            icon-name="rt-base-close"
            type="plain"
            icon-size="20"
            color-type="neutral-regular"
            text
            @click.stop="close"
          />
        </div>
        <rt-divider />
        <div class="rt-content">
          <div
            :class="{ 'no-title': !title }"
            class="title-message"
          >
            <div
              v-if="title"
              class="rt-content__title"
            >
              {{ title }}
            </div>
            <div
              v-if="message"
              class="rt-content__message"
            >
              {{ message }}
            </div>
          </div>
          <div class="rt-content__operate">
            <div class="operate-look">
              <rt-button
                text
                type="plain"
                size="small"
                @click="lookDetail"
              >
                {{
                  $tx('查看', 'xpc.common.look')
                }}
              </rt-button>
            </div>
            <div
              v-if="showNext"
              class="operate-pageturn"
            >
              <rt-button
                text
                suffix-icon="rt-base-arrow_right"
                color-type="neutral-secondary"
                @click="nextClick"
              >
                {{
                  $tx('下一条', 'xpc.common.next')
                }}
              </rt-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
import Notification from './main.js';
import RtIcon from '../../icon/rtIcon.vue';
import RtButton from '../../button/rtButton.vue';
import RtDivider from '../../divider/rtDivider.vue';
let typeMap = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};

export default {
  components: { RtIcon, RtButton, RtDivider },
  data () {
    return {
      visible: false,
      title: '',
      message: '',
      duration: 4500,
      type: '',
      showClose: true,
      customClass: '',
      iconClass: '',
      onClose: null,
      onClick: null,
      closed: false,
      verticalOffset: 0,
      showNext: false,
      dangerouslyUseHTMLString: false,
      position: 'bottom-right',
      offset: 0,
      clickLook: null
    };
  },

  computed: {
    typeClass () {
      return this.type && typeMap[this.type] ? `rt-icon-${typeMap[this.type]}` : '';
    },

    horizontalClass () {
      return this.position.indexOf('right') > -1 ? 'right' : 'left';
    },

    verticalProperty () {
      return /^top-/.test(this.position) ? 'top' : 'bottom';
    },

    positionStyle () {
      return {
        [this.verticalProperty]: `${this.verticalOffset}px`
      };
    }
  },

  watch: {
    closed (newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    }
  },
  mounted () {
    this.startTimer();
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.keydown);
  },

  methods: {
    lookDetail (event) {
      if (typeof this.clickLook === 'function') {
        this.clickLook();
      }
      event.stopPropagation();
    },
    nextClick (event) {
      var instances = Notification.getInstances();
      if (instances.length > 2) {
        //   var verticalOffset1 = instances[0].verticalOffset;
        // var verticalOffset2 = instances[1].verticalOffset;
        instances[0].close();
      }
      event.stopPropagation();
    },
    destroyElement () {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },

    click () {
      if (typeof this.onClick === 'function') {
        this.onClick();
      }
    },

    close () {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
      var instances = Notification.getInstances();
      if (instances.length > 2) {
        instances[1].visible = true;
        instances[0].showNext = false;
        instances[1].showNext = true;
        instances[1].verticalOffset = this.offset + 16;
        instances[0].verticalOffset = instances[1].verticalOffset + instances[0].$el.offsetHeight + 16;
      } else if (instances.length === 2) {
        instances[1].visible = true;
        instances[0].showNext = false;
        instances[1].verticalOffset = this.offset + 16;
        instances[0].verticalOffset = instances[1].verticalOffset + instances[0].$el.offsetHeight + 16;
      } else if (instances.length === 1) {
        if (instances[0].verticalOffset !== this.offset + 16) {
          instances[0].verticalOffset = this.offset + 16;
        } else {
          instances[0].verticalOffset = this.offset + 17;
          setTimeout(() => {
            instances[0].verticalOffset = this.offset + 16;
          });
        }
      }
    },

    clearTimer () {
      clearTimeout(this.timer);
    },

    startTimer () {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },
    keydown (e) {
      if (e.keyCode === 46 || e.keyCode === 8) {
        this.clearTimer(); // detele 取消倒计时
      } else if (e.keyCode === 27) {
        // esc关闭消息
        if (!this.closed) {
          this.close();
        }
      } else {
        this.startTimer(); // 恢复倒计时
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// main.vue?5d0ec6c8